import { COMPARISON_FILTER } from './comparisonfilter.type';

export const setComparisonfilter = (setFilter) => {
  return {
    type: COMPARISON_FILTER,
    payload: setFilter
  };
};
